import React from "react";
import styles from "./index.module.css";
import Button from "../../Components/Button";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.pageNotFoundContainer}>
      Page Not Found
      <Button
        onClick={() => navigate("/", { replace: true })}
        fitChild
        className={styles["back-button"]}
      >
        {"Go Back"}
      </Button>
    </div>
  );
};

export default PageNotFound;
